import {adminClient} from 'helper/httpClient';
import {useSWRTemplate} from 'hooks/dataHooksTemplate';

export const useCampaignList = (options = {}) => {
    const {request = true} = options;
    const swr = useSWRTemplate({
        key: request ? ['ib', 'campaign', 'list'] : null,
        request: async () => {
            const {result} = await adminClient.get(['ib', 'campaign']);
            return Array.isArray(result) ? result : [];
        },
        defaultValue: [],
    });
    return swr;
};

// Phase 4 (2026-10-19): Workflow 收件箱审批 ibChannel 时, 按 request.params.campaignId
// 调 GET /admin/v1/ib/campaign/:id 拉单桶详情, 4 组预填. null id → 不发请求.
export const useCampaignById = (id) => {
    const swr = useSWRTemplate({
        key: id ? ['ib', 'campaign', id] : null,
        request: async () => {
            const {result} = await adminClient.get(['ib', 'campaign', id]);
            return result || null;
        },
        defaultValue: null,
    });
    return swr;
};

// Phase 4 (2026-10-19): admin approve 必传 4 个 MT 组; 后端 model 层做权威校验 (trim + 非空 + ≤30).
// 字段顺序与 updateCampaign payload 一致 (mt4STDGroup / mt4PROGroup / mt5STDGroup / mt5PROGroup).
export const approveCampaign = async (id, groups) => {
    const {result} = await adminClient.post(['ib', 'campaign'], {
        id,
        action: 'approve',
        mt4STDGroup: groups?.mt4STDGroup,
        mt4PROGroup: groups?.mt4PROGroup,
        mt5STDGroup: groups?.mt5STDGroup,
        mt5PROGroup: groups?.mt5PROGroup,
    });
    return result;
};

export const rejectCampaign = async (id) => {
    const {result} = await adminClient.post(['ib', 'campaign'], {
        id,
        action: 'reject',
    });
    return result;
};

export const updateCampaign = async (id, payload) => {
    const {result} = await adminClient.put(
        ['ib', 'campaign', id],
        payload || {},
    );
    return result;
};

export const deleteCampaign = async (id) => {
    const {result} = await adminClient.del(['ib', 'campaign', id]);
    return result;
};
